import { Fragment, useMemo } from "react";

import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { IconButton } from "@/DesignSystem";
import { MedicalItemRiskFactorHelper } from "@/Patient/Helpers/MedicalItemRiskFactorHelper";
import { RiskFactorInfo } from "./RiskFactorInfo";

import styles from "./RiskFactorEditList.module.scss";

import XIcon from "@/DesignSystem/Atoms/Icons/Types/X/x-bold.svg";

interface IRiskFactorEditListProps {
    riskFactors: RiskFactorInfo[];
    onRemove: (riskFactor: RiskFactorInfo) => void;
    onChangeDetails: (id: string, details: string) => void;
}

function RiskFactorEditList(props: Readonly<IRiskFactorEditListProps>): JSX.Element {
    const ids = useMemo(
        () => {
            const idsToReturn: string[] = [];
            let id = 0;
            for (const riskFactor of props.riskFactors) {
                if (riskFactor.RiskFactorCodeId) {
                    idsToReturn.push(`riskFactorDetails-${id}`);
                    id++;
                }
                else {
                    idsToReturn.push("");
                }
            }
            return idsToReturn;
        },
        [props.riskFactors, props.riskFactors.length]
    );
    return (
        <div className={styles.riskFactorEditList}>
            {props.riskFactors.map((riskFactorItem: RiskFactorInfo, index: number) => (
                <Fragment key={riskFactorItem.Id}>
                    <strong>{MedicalItemRiskFactorHelper.getRiskFactorLabel(riskFactorItem)}</strong>
                    {riskFactorItem.RiskFactorCodeId
                        ? (
                            <TextboxControl
                                id={ids[index]}
                                className="form-control input riskfactor-details-input"
                                style={{ width: "300px" }}
                                value={riskFactorItem.Details}
                                onChange={text => props.onChangeDetails(riskFactorItem.Id, text)}
                                maxLength={250}
                            />
                        )
                        : <div />
                    }
                    <div>
                        <IconButton
                            variant="error"
                            category="status-icon"
                            size="sm"
                            onClick={() => props.onRemove(riskFactorItem)}
                        >
                            <XIcon />
                        </IconButton>
                    </div>
                </Fragment>
            ))}
        </div>
    );
}

export { RiskFactorEditList };
